export const BASE_ADD_NOTIFICATION = 'baseAddNotification'
export const BASE_CLEAR_NOTIFICATIONS = 'baseClearNotifications'
export const BASE_REMOVE_NOTIFICATION = 'baseRemoveNotification'